import { useState } from "react";
import { X } from "lucide-react";
import toastr from "toastr";
import { rejectLoyaltyReward } from "../../services/api";

export default function RejectRewardModal({ target, onClose, onRejected }) {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!reason.trim()) { setError("Please enter a reason for rejecting this reward."); return; }
    setBusy(true);
    try {
      const res = await rejectLoyaltyReward(target.reward_id, reason.trim());
      if (res.status?.success) { toastr.success(res.message); onRejected(); }
      else toastr.error(res.message);
    } catch { toastr.error("Reject failed. Please try again."); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[60]">
      <form onSubmit={submit} className="bg-white rounded-lg shadow-xl w-full max-w-[480px]">
        <div className="flex justify-between items-center border-b px-6 py-4">
          <h3 className="text-lg font-semibold">Reject reward</h3>
          <button type="button" onClick={onClose} className="text-gray-500 hover:text-gray-700"><X size={20} /></button>
        </div>
        <div className="p-6 space-y-2">
          <div className="text-sm text-gray-600">{target.reward_name} · {target.created_by_store_name}</div>
          <label className="block text-sm font-medium">Reason for rejection <span className="text-red-500">*</span></label>
          <textarea value={reason} rows={4} maxLength={1000} placeholder="Tell the store what to fix"
            onChange={(e) => { setReason(e.target.value); if (error) setError(""); }}
            className="w-full px-3 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]" />
          {error && <p className="text-xs text-red-600">{error}</p>}
        </div>
        <div className="flex gap-2 justify-end border-t px-6 py-4">
          <button type="button" onClick={onClose} className="px-4 py-2 rounded-xl bg-gray-200 text-gray-800 hover:bg-gray-300">Cancel</button>
          <button type="submit" disabled={busy} className="px-4 py-2 rounded-xl bg-red-600 text-white hover:bg-red-700 disabled:opacity-50">Reject reward</button>
        </div>
      </form>
    </div>
  );
}